import React from 'react'
import { AllCategoriesWithLetters } from 'SRC/modules/categories/components'

export const ChoiceCategoryPage = () => (
  <AllCategoriesWithLetters
    textSearchPlaceholder='upišite ovdje šta prodajete... npr. automobil'
    baseHref='/addAd'
    baseAs='/dodaj/'
  />
)
